import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "absolute bottom-0 inset-x-0 px-container pb-16 lg:pb-32" }
const _hoisted_2 = { class: "font-display text-center" }
const _hoisted_3 = { class: "mb-4 text-2xl lg:text-4xl" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" MALLORCA, UNA ISLA DE PELÍCULA ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" MALLORCA, UNA ILLA DE PEL·LÍCULA ")
const _hoisted_6 = { class: "text-6xl lg:text-8xl text-amff-teal" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" VIERNES 29/07 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" DIVENDRES 29/07 ")
const _hoisted_9 = { class: "mt-4 text-center text-2xl lg:text-4xl font-display" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 11h - Teatre Mar i Terra ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 11h - Teatre Mar i Terra ")
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, " Cada vez son más los turistas que eligen el destino de sus próximos viajes o vacaciones a partir de sus películas o series favoritas. Mallorca ha sido plató de rodajes como “El atlas de las nubes”, las calles de Valldemossa de la película “Pan de Limón”, las playas de Calvià de la obra de culto “El Mago” o Andratx de la serie “The Night Manager”. Y cada vez son más los destinos turísticos que incorporan el cine como parte de su promoción, o que crean mapas o rutas para facilitar la visita a los lugares en los que se rodaron las escenas que han quedado en la memoria. “Una Isla de Película” propone un recorrido por estos lugares que han emocionado a través de la pantalla. ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("strong", null, "Participan:", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, "Miguel Sanz - Turespaña"),
  /*#__PURE__*/_createVNode("li", null, "Carlos Fernández - FILMAX"),
  /*#__PURE__*/_createVNode("li", null, "Ali Urrosolo - Red de Turismo de Cine"),
  /*#__PURE__*/_createVNode("li", null, "Stefan Roesch - autor de “The Experiences of"),
  /*#__PURE__*/_createVNode("li", null, "Film Tourists” por streaming")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("strong", null, "Modera:", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, "Andreu Serra - Fundació Mallorca Turisme")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, " Cada vegada són més els turistes que trien la destinació dels seus pròxims viatges o vacances a partir de les seves pel·lícules o sèries favorites. El Madrid de “La Casa de Paper”, el Sant Joan de Gastelugatxe de “Joc de Trons”, o els carrers de Valldemossa de la pel·lícula “Pa de Llimona” són alguns exemples. I cada vegada són més les destinacions turístiques que incorporen el cinema com a part de la seva promoció, o que creguin mapes o rutes per a facilitar la visita als llocs en els quals es van rodar les escenes que han quedat en la memòria. “Una Illa de Pel·lícula” proposa un recorregut per aquests llocs que han emocionat a través de la pantalla. ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("strong", null, "Participan:", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, "Miguel Sanz - Turespaña"),
  /*#__PURE__*/_createVNode("li", null, "Carlos Fernández - FILMAX"),
  /*#__PURE__*/_createVNode("li", null, "Ali Urrosolo - Red de Turismo de Cine"),
  /*#__PURE__*/_createVNode("li", null, "Stefan Roesch - autor de “The Experiences of"),
  /*#__PURE__*/_createVNode("li", null, "Film Tourists” per streaming")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("strong", null, "Modera:", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, "Andreu Serra - Fundació Mallorca Turisme")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Hero = _resolveComponent("Hero")
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PageContent = _resolveComponent("PageContent")
  const _component_PageContainer = _resolveComponent("PageContainer")
  const _component_FollowFestival = _resolveComponent("FollowFestival")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Hero, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h1", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              (_ctx.currentLang === 'es')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_4
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.currentLang === 'cat')
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_5
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_6, [
              (_ctx.currentLang === 'es')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_7
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.currentLang === 'cat')
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_8
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            (_ctx.currentLang === 'es')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_10
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.currentLang === 'cat')
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_11
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_PageContainer, null, {
      default: _withCtx(() => [
        _createVNode(_component_PageTitle),
        (_ctx.currentLang === 'es')
          ? (_openBlock(), _createBlock(_component_PageContent, { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _hoisted_17
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_PageContent, { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_18,
                _hoisted_19,
                _hoisted_20,
                _hoisted_21,
                _hoisted_22,
                _hoisted_23
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_FollowFestival)
  ], 64))
}